import React from 'react';
import { gameName } from '../../utils/gameNames';

// Name for people, raw id underneath for log lookups.
const GameName = ({ gameId }) => {
  const name = gameName(gameId);
  if (name === (gameId ?? '')) return name;
  return (
    <>
      {name}
      <div className="small text-muted">{gameId}</div>
    </>
  );
};

export default GameName;
